/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { WorkspaceStatus } from '../models/WorkspaceStatus';

export class Workspace {
  /**
  * The unique identifier of the workspace
  */
  'id': string;
  /**
  * The name of the workspace
  */
  'name': string;
  /**
  * Cloud provider: aws, gcp, azure
  */
  'cloud': string;
  /**
  * Cloud region
  */
  'region': string;
  'status': WorkspaceStatus;
  /**
  * The timestamp when the workspace was created
  */
  'createdAt': Date;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": "tobedefined"
    },
    {
      "name": "cloud",
      "baseName": "cloud",
      "type": "string",
      "format": ""
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "status",
      "baseName": "status",
      "type": "WorkspaceStatus",
      "format": ""
    },
    {
      "name": "createdAt",
      "baseName": "createdAt",
      "type": "Date",
      "format": "date-time"
    }  ];

  static getAttributeTypeMap() {
    return Workspace.attributeTypeMap;
  }

  public constructor() {
  }
}



